<template>
	<div class="nav">
		<div class="nav-item" v-for="item in data" :key="item.value" @click="navClick(item)" :class="getAcive(item)">
			{{ item.label }}
			<span class="nav-span" v-if="item.hasResult">*</span>
		</div>
	</div>
</template>

<script>

export default {
	data() {
		return {

		};

	},
	props: ['data'],
	computed: {

	},
	created() { },

	methods: {
		getAcive(item) {
			const { path } = this.$route;
			if (path.indexOf(item.path) != -1) {
				return 'active'
			}
			return ''
			// let { path } = this.$route;
			// return this.data.find(i => i.path === path)?.value
		},
		navClick(item) {
			this.$emit("click", item);
		},
	},
};
</script>

<style scoped>
.nav {
	display: flex;
	flex: 0 50px;
	/* padding: 0 20px; */
	border-bottom: #f6f6f6 1px solid;
}

.nav-item {
	font-size: 14px;
	height: 50px;
	margin: 5px 0.4em;
	padding: 1em 0.8em;
	position: relative;
	width: fit-content;
	cursor: pointer;
	box-sizing: border-box;
	word-break: keep-all;
	display: flex;
	align-content: center;
	align-items: center;
	transition: all 0.18s cubic-bezier(0.23, 1, 0.32, 1);
}

.nav-span {
	position: absolute;
	top: 10px;
	right: 0;
	/* font-size: 24px; */
}

.active {
	font-size: 14px;
	/* font-weight: 600; */
}

.active::after {
	content: "";
	width: 60%;
	height: 3px;
	background: #4b91ff;
	left: 50%;
	transform: translateY(-50%);
	top: 85%;
	transform: translateX(-50%);
	position: absolute;
}
</style>